import {Permissions} from "./Enums/Permissions";
import {Functions} from "./Enums/Functions";
import { TipStatus } from "./Enums/TipStatus";

export default class WorkerData {
    public Guid: string;
    public UserId: string;
    public FirstName: string;
    public LastName: string;
    public Debt: number
    public Permission: Permissions;
    public Function: Functions;
    public PinTip: number;
    public CashTip: number;
    public RoundedTip: number;
    public TipStatus: TipStatus;
    public Username: string;

    public PreviousTipsReceived: boolean = true;

    constructor(guid: string, userId: string, firstName: string, lastName: string, debt: number, roundedTip: number, permission: Permissions, func: Functions, cashTip: number, pinTip: number) {
        this.Guid = guid;
        this.UserId = userId;
        this.FirstName = firstName;
        this.LastName = lastName;
        this.Debt = debt;
        this.Permission = permission;
        this.Function = func;
        this.CashTip = cashTip;
        this.PinTip = pinTip;
        this.RoundedTip = roundedTip;
        this.TipStatus = TipStatus.NotReady;
        this.Username = "";
    }
}